import { useState } from 'react';

import DeleteOutlined from '../../../../assets/common/DeleteOutlined';
import DownCaretIcon from '../../../../assets/DownCaretIcon';
import ExtractionFields from './ExtractionFields';
import styles from './PromptContainer.module.scss';

const ExtractionFieldContainer = ({ field, index, canDelete, onDelete }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const handleExpand = () => setIsExpanded((prev) => !prev);

  return (
    <li className='mb-16'>
      <div
        role='button'
        tabIndex={0}
        className={`${styles.expandable_header} ${isExpanded ? styles.expanded : ''}`}
        onClick={handleExpand}
        onKeyDown={(e) => e.key === 'Enter' && handleExpand()}
      >
        <div className='flex gap-8 align-center'>
          <p className='fs-14 fw-600'>
            Field
            {` ${index + 1}`}
          </p>
        </div>
        <div className='flex gap-8 align-center'>
          {canDelete && (
            <button
              type='button'
              title='Remove Field'
              className='flex align-center'
              onClick={(e) => {
                e.stopPropagation();
                onDelete();
              }}
            >
              <DeleteOutlined color='var(--grey-8)' />
            </button>
          )}
          <span
            role='img'
            aria-label={isExpanded ? 'collapse' : 'expand'}
            className={`${styles.expanded_btn} ${isExpanded ? styles.expanded : ''}`}
          >
            <DownCaretIcon />
          </span>
        </div>
      </div>

      <section className={styles.fields} style={{ display: isExpanded ? 'block' : 'none' }}>
        <ExtractionFields field={field} index={index} />
      </section>
    </li>
  );
};

export default ExtractionFieldContainer;
